import axios from "axios";
import {baseURL} from "../ApiService";

export const getAllUserList = async (page, size, filters) => {
    let url = `${baseURL}/api/user/all?page=${page}&size=${size}`;
    Object.keys(filters).forEach(key => {
        if(filters[key]) {
            url += `&${key}=${filters[key]}`;
        }
    });
    return axios.get(url)
}

export const getAllImageList = async (currentPage, pageSize) => {
    return axios.get(`${baseURL}/api/web/getImgAI-history?page=${currentPage}&size=${pageSize}`)
}

export const generateImageViaGetImg = async (prompt, size) => {
    return axios.get(`${baseURL}/api/web/getImgAI?prompt=${prompt}&size=${size}`)
}

export const askGPT = async (promptId, payload, lan) => {
    return axios.post(`${baseURL}/api/prompt/test?promptId=${promptId}&lan=${lan}`, payload)
}

export const searchBookWords = async (page, size, word) => {
    return axios.get(`${baseURL}/api/web/search-book-word?page=${page}&size=${size}&word=${word}`)
}

export const generateWordImage = async (wordId, payload) => {
    return axios.post(`${baseURL}/api/web/update-book-image?wordId=${wordId}`, payload)
}

export const googleTTS = async (text) => {
    const encodedText = encodeURIComponent(text);
    return axios.get(`${baseURL}/api/web/google-tts?text=${encodedText}&lan=en-GB&voice=en-GB-Standard-N`);
}

export const getAllScheduledJobs = async (currentPage, pageSize) => {
    return axios.get(`${baseURL}/api/web/schedule-jobs?page=${currentPage}&size=${pageSize}`)
}

export const getAllUserFeedbacks = async (page, size, filters) => {
    let url = `${baseURL}/api/user/feedbacks?page=${page}&size=${size}`;
    Object.keys(filters).forEach(key => {
        if(filters[key]) {
            url += `&${key}=${filters[key]}`;
        }
    });
    return axios.get(url)
}

export const translatePrompt = async (id, language) => {
    return axios.get(`${baseURL}/api/prompt/translate?promptId=${id}&language=${language}`)
}

export const swapBookOrder = async (book1Id, book2Id) => {
    return axios.get(`${baseURL}/api/book/swap?book1Id=${book1Id}&book2Id=${book2Id}`)
}